var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_2201)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3594 26.2391H4.64153C3.68791 26.2391 2.98371 25.2346 3.34338 24.3107C5.01223 20.039 8.93286 17.5918 13.4998 17.5918C18.0681 17.5918 21.9887 20.039 23.6576 24.3107C24.0173 25.2346 23.3131 26.2391 22.3594 26.2391ZM7.9875 8.94452C7.9875 5.76519 10.4611 3.17965 13.4998 3.17965C16.5398 3.17965 19.0121 5.76519 19.0121 8.94452C19.0121 12.1238 16.5398 14.7094 13.4998 14.7094C10.4611 14.7094 7.9875 12.1238 7.9875 8.94452ZM26.9402 25.7145C25.9383 20.8734 22.8046 17.3006 18.68 15.6793C20.8656 13.8388 22.1403 10.8627 21.6718 7.60411C21.1288 3.8238 18.1219 0.798751 14.492 0.357739C9.48134 -0.251895 5.23135 3.82676 5.23135 8.94452C5.23135 11.6684 6.43854 14.0954 8.32099 15.6793C4.19504 17.3006 1.06267 20.8734 0.0594324 25.7145C-0.304379 27.4742 1.05165 29.1215 2.77286 29.1215H24.2267C25.9493 29.1215 27.3054 27.4742 26.9402 25.7145Z",
    fill: "#0367D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_2201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28.8243,
    fill: "white",
    transform: "translate(0 0.297241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b3a94d67ad05c5119e3ee9b73f66142e.svg";
export { ForwardRef as ReactComponent };